/**
 * @desc 保存
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.BizPermissionApplyRolesRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bizPermissionApplyRoles/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
